import AtomNotice from '@/components/Atoms/AtomNotice/AtomNotice'
import { digitsMask } from '@/utils/forms/inputMasks'

import { labelWithTooltip } from '../../RequiredLabel/labelWithTooltip'
import cn from '../ConfigModal.module.scss'
import {
  PriceBooleanSelectField,
  type PriceFieldContext,
  PriceTextField,
} from './PriceFields'

function PriceGuardsFields({ context }: { context: PriceFieldContext }) {
  const rrcColumnError = context.errors.rrcColumnNumber?.message

  return (
    <>
      {rrcColumnError && (
        <AtomNotice type="error">
          Колонка РРЦ: {rrcColumnError} — укажите её на шаге «Настройки» в блоке
          «Файл и колонки»
        </AtomNotice>
      )}
      <div className={cn.grid}>
        <PriceTextField
          context={context}
          name="vatRatePercent"
          title="Ставка НДС, %"
          mask={digitsMask}
        />
        <PriceBooleanSelectField
          context={context}
          name="pricesIncludeVat"
          title="Цены в файле с НДС"
          trueLabel="Да"
          falseLabel="Нет"
        />
        <PriceTextField
          context={context}
          name="minMarkupPercent"
          title={labelWithTooltip(
            'Мин. наценка к закупке, %',
            'Цена сегмента ниже закупки с этой наценкой убирается'
          )}
          mask={digitsMask}
        />
        <PriceTextField
          context={context}
          name="spikeAlertPercent"
          title={labelWithTooltip(
            'Скачок закупки, %',
            'Порог скачка закупки к прошлой загрузке для алерта. Скачок у половины позиций и больше — цены загрузки не применяются'
          )}
          mask={digitsMask}
        />
        <PriceTextField
          context={context}
          name="maxInvalidPricePercent"
          title={labelWithTooltip(
            'Макс. % строк без закупки',
            'При большей доле загрузка получит «Предупреждение» и алерт'
          )}
          mask={digitsMask}
        />
        <PriceBooleanSelectField
          context={context}
          name="capByRrc"
          title="Цена сегментов относительно РРЦ"
          trueLabel="Не выше РРЦ"
          falseLabel="Без ограничения"
        />
      </div>
    </>
  )
}

export default PriceGuardsFields
